import { useCallback, useEffect } from 'react'

import { MapBrowserEvent } from 'ol'
import { Coordinate } from 'ol/coordinate'
import { transform } from 'ol/proj'

import { useMap } from '../useMap'

interface UseFeatureClickProps {
  onClick?: (coordinate: Coordinate) => void
}

export function useClick(props: UseFeatureClickProps): void {
  const { onClick } = props

  const { map } = useMap()

  const onMouseClick = useCallback(
    (event: MapBrowserEvent<PointerEvent>) => {
      if (!onClick) return
      onClick(transform(event.coordinate, 'EPSG:3857', 'EPSG:4326'))
    },
    [map, onClick],
  )

  useEffect(() => {
    map.on('click', onMouseClick)
    return () => {
      map.un('click', onMouseClick)
    }
  }, [onMouseClick])
}
